<template>
  <div class="filter__slider">
    <vue-slider :min="min" :max="max" :enable-cross="false" :tooltip="'always'" v-model="initValue" v-on:drag-end="changedValue">
      <template v-slot:tooltip="{ value }">
        <div class="vue-slider-dot-tooltip-inner">{{ `${value} ${unit}` }}</div>
      </template>
    </vue-slider>
  </div>
</template>

<script type="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import VueSlider from 'vue-slider-component/dist/vue-slider-component.common';

@Component({
  components: {VueSlider}
})
export default class Slider extends Vue {
  @Prop({default: '', type: String}) unit: string;
  @Prop({default: 0, type: Number}) min: number;
  @Prop({default: 0, type: Number}) max: number;
  @Prop({default: () => [], type: Array}) value: Array<number>;

  private initValue: Array<number> = [];

  private mounted() {
    this.initValue = this.value;
  }

  private changedValue() {
    this.$emit('input', this.initValue);
  }
}
</script>